import React, { useEffect, useState, forwardRef } from "react";
import { Button, Form, Col, Row, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchId,
  fetchIdNoloading,
  selectId,
  selectLoading,
} from "./settingJourneySlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  paramsMasterAll,
  setOptionsMaster,
  showDialog,
  useForceUpdate,
  setOptionsSelect,
  hari,
  getValueOptions,
  customStyles,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import CurrencyInput from "react-currency-input-field";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import MultiSelectAll from "../../utility/MultiSelectAll";

import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import { fetchCustomer, selectCustomer } from "../customer/customerSlice";
import { fetchUser, selectDataUser } from "../user/userSlice";

import SVG from "react-inlinesvg";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import {
  GoogleMap,
  Marker,
  DirectionsRenderer,
  useLoadScript,
} from "@react-google-maps/api";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { fetchSynch, selectDataSynch } from "../company/companySlice";

const libraries = ["places"];
const mapContainerStyle = { width: "100%", height: "600px" };
const center = { lat: -6.2088, lng: 106.8456 };

export const SettingJourneyCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const user = useSelector(selectUser);
  const dataUser = useSelector(selectDataUser);
  const dataId = useSelector(selectId);
  const dataCustomer = useSelector(selectCustomer);
  const { id } = useParams();
  const forceUpdate = useForceUpdate();
  const { SearchBar } = Search;
  const synch = useSelector(selectDataSynch);

  const [visit, setVisit] = useState("");
  const [customer, setCustomer] = useState("");
  const [sales, setSales] = useState("");
  const [optionsCust, setOptionsCust] = useState([]);
  const [optionsUser, setOptionsUser] = useState([]);
  const [show, setShow] = useState("");

  const [listCustomer, setListCustomer] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [optionsFreq, setOptionsFreq] = useState([]);
  const [frequensi, setFrequensi] = useState("");
  const [kunjungan, setKunjungan] = useState([]);
  const [test, setTest] = useState([]);

  const [points, setPoints] = useState([]);

  const paramsId = {
    user_id: id,
  };

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(fetchSynch());

      // await dispatch(fetchCustomer(paramsMasterAll));
      // await dispatch(fetchUser({ ...paramsMasterAll, roles: "SALES" ,is_active: true}));

      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId) {
      const initData = dataId.customers.map((item, index) => {
        return {
          ...item,
          no: index + 1,
          journey_setting_details: item.journey_setting_details.map((item) => {
            return {
              ...item,
              label: item.hari_kunjungan,
              value: item.hari_kunjungan,
            };
          }),
        };
      });
      setListCustomer(initData);
    }
  }, [dataId]);

  useEffect(() => {
    if (synch) {
      setOptionsSelect(synch, "Frekuensi Kunjungan", setOptionsFreq);
    }
  }, [synch]);

  const handleSave = async () => {
    const initData = listCustomer.map((item, index) => {
      return {
        ...item,
        no: index + 1,
        journey_setting_details:
          item.journey_setting_details === null
            ? []
            : item.journey_setting_details?.map((item) => {
                return {
                  ...item,
                  hari_kunjungan: item.value,
                };
              }),
      };
    });
    const params = initData;
    console.log(initData, "initdata");

    try {
      const response =
        id === undefined
          ? await dispatch(addItem(params))
          : await dispatch(editItem(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleChangeFrequensi = (e) => {
    if (e === null) {
      e = undefined;
      setFrequensi("");

      const newData = kunjungan.map((item) => {
        return { ...item, checked: false };
      });

      setKunjungan(newData);
    } else {
      setFrequensi(e.value);
    }
  };

  const handleActionChange = async (e, row, rowIndex, formatExtraData) => {
    // Cari indeks data yang sesuai dengan customer_code
    const custCode = formatExtraData.findIndex(
      (data) => data.customer_code === row.customer_code
    );
    if (custCode !== -1) {
      // Pastikan data ditemukan
      if (e === null) {
        formatExtraData[custCode].frequen = null;
        formatExtraData[custCode].journey_setting_details = [];
      } else {
        formatExtraData[custCode].frequen = e.value;
      }

      setListCustomer(formatExtraData);
      forceUpdate();
    } else {
      console.error("Data dengan customer_code yang diberikan tidak ditemukan");
    }
  };

  const frequensiFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Select
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        options={optionsFreq}
        onChange={(e) => {
          handleActionChange(e, row, rowIndex, formatExtraData);
        }}
        isSearchable={false}
        placeholder="Select"
        value={getValueOptions(row.frequen, optionsFreq)}
        isClearable={true}
      />
    );
  };

  const kunjunganFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Select
        value={row.journey_setting_details}
        onChange={(selectedOptions) => {
          const custCode = formatExtraData.findIndex(
            (data) => data.customer_code === row.customer_code
          );

          formatExtraData[custCode].journey_setting_details = selectedOptions;
          setListCustomer(formatExtraData);
          forceUpdate();
        }}
        options={allDay}
        menuPortalTarget={document.body}
        isMulti
        styles={{
          multiValue: (base) => ({
            ...base,
            backgroundColor: "#F64E60",
            color: "white",
          }),
          multiValueLabel: (base) => ({
            ...base,
            color: "white",
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999, // Atur nilai z-index sesuai kebutuhan
          }),
        }}
        name="colors"
        className="basic-multi-select"
        classNamePrefix="select"
      />
    );
  };

  const columnsCustomer = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
      editable: false,
    },

    {
      text: "code",
      dataField: "customer_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      editable: false,
    },
    {
      text: "store name",
      dataField: "customer_store_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      editable: false,
    },
    {
      text: "kecamatan",
      dataField: "customer_kecamatan",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
      // style: { minWidth: "150px" },
    },
    {
      text: "customer group",
      dataField: "customer_group_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
      // style: { minWidth: "150px" },
    },
    {
      text: "frequensi",
      dataField: "frequen",
      formatter: frequensiFormatter,
      formatExtraData: listCustomer,
      editable: false,
      headerAlign: "center",
      style: { minWidth: "180px" },
    },
    {
      text: "Hari kunjungan",
      dataField: "journey_setting_details",
      formatter: kunjunganFormatter,
      formatExtraData: listCustomer,
      editable: false,
      headerAlign: "center",
      style: { minWidth: "250px" },
    },
    // {
    // {
    //   text: "Hari kunjungan",
    //   dataField: "bisparhari_kunjungan",
    //   editable: false,
    //   headerAlign: "center",
    //   editorRenderer: (
    //     editorProps,
    //     value,
    //     row,
    //     column,
    //     rowIndex,
    //     columnIndex
    //   ) => (
    //     <Select
    //       {...editorProps}
    //       options={allDay}
    //       value={
    //         value
    //           ? value.map((val) =>
    //               allDay.find((option) => option.value === val)
    //             )
    //           : null
    //       }
    //       onChange={(selectedOptions) =>
    //         editorProps.onUpdate(
    //           selectedOptions
    //             ? selectedOptions.map((option) => option.value)
    //             : null
    //         )
    //       }
    //       isMulti
    //     />
    //   ),
    // },
  ];

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined
              ? "Create Journey Setting"
              : "Edit Journey Setting"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>
            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>

        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Sales Code</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      disabled
                      value={dataId?.company_sales_code}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Sales Name</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      disabled
                      value={dataId?.company_sales_name}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>

          <hr />
          <ToolkitProvider
            keyField="customer_id"
            data={listCustomer}
            columns={columnsCustomer}
            search
          >
            {(props) => (
              <div>
                <Row>
                  <Col>
                    <div className="float-right">
                      <SearchBar
                        {...props.searchProps}
                        placeholder="Search .."
                      />
                    </div>
                  </Col>
                </Row>
                <div className="table-container ">
                  <BootstrapTable
                    // wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center"
                    bootstrap4
                    bordered={true}
                    {...props.baseProps}
                    cellEdit={cellEditFactory({
                      mode: "click",
                      blurToSave: true,
                    })}
                  />
                </div>
              </div>
            )}
          </ToolkitProvider>
        </CardBody>
      </Card>
    </>
  );
};
